import React from 'react'

export class ContentHeader extends React.Component {
  image() {
    return this.props.category ? this.props.category.headerImageUrl : this.props.defaultImageUrl
  }

  title() {
    const scope  = {scope: 'discover.categories.index'},
          category = this.props.category
    if (category) return (
      <span>
        { I18n.t('all_projects_about', scope) }
        <strong> { category.name } </strong>
      </span>
    )
    else return I18n.t('find_your_project', scope)
  }

  render() {
    const style = { backgroundImage: `url(${this.image()})` }

    return (
      <div className="generic-content-header preserves-space-for-transparent-header" style={style} >
        <div className="container">
          <div className="row">
            <div className="col-md-24">
              <h1 className="font-desktop-xxl font-phone-lg">{this.title()}</h1>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
